import {createSelector} from 'reselect';

import type {NutshellState} from '../../store';

export const getReportState = (state: NutshellState) => state.reports;

export const getIsFilterDrawerOpen = createSelector([getReportState], (reportState) => {
    return reportState.isFilterDrawerOpen;
});

// LeadsReport || ActivityReport state
const getCurrentReportState = createSelector(
    [getReportState],
    (reportState) => reportState.leadsReport
);
const getCurrentReportTableData = createSelector(
    [getCurrentReportState],
    (currentReportState) => currentReportState.tableData
);
export const getCurrentReportTableRows = createSelector(
    [getCurrentReportTableData],
    (currentReportTableData) => {
        let rows = currentReportTableData.rows;
        if (rows && !NutClientConfig.hasQuotas) {
            // @ts-expect-error
            rows = rows.map((detail) => {
                // @ts-expect-error
                const newTotals = detail.totalsByReport.filter((report) => report.name !== 'Quota');
                detail.totalsByReport = newTotals;

                return detail;
            });
        }

        return rows;
    }
);
export const getCurrentReportTableTotals = createSelector(
    [getCurrentReportTableData],
    (currentReportTableData) => {
        const totals = currentReportTableData.totals;

        if (totals && !NutClientConfig.hasQuotas) {
            const newTotalsByReport = totals.totalsByReport.filter(
                // @ts-expect-error
                (report) => report.name !== 'Quota'
            );
            totals.totalsByReport = newTotalsByReport;
        }

        return totals;
    }
);
const getTimeseriesChartState = createSelector(
    [getCurrentReportState],
    (currentReportState) => currentReportState.timeseriesChart
);
export const getCurrentReportChartIsLoading = createSelector(
    [getTimeseriesChartState],
    (timeseriesChartState) => timeseriesChartState.isLoading
);
export const isChartTimedOut = createSelector(
    [getTimeseriesChartState],
    (timeseriesChartState) => timeseriesChartState.isTimedOut
);

export const isChartErrored = (state: NutshellState) => getTimeseriesChartState(state).isErrored;

export const getCurrentReportChartData = createSelector(
    [getTimeseriesChartState],
    (timeseriesChartState) => timeseriesChartState.chartData
);
export const getCurrentReportChartPrefix = createSelector(
    [getTimeseriesChartState],
    (timeseriesChartState) => timeseriesChartState.prefix
);
export const getCurrentReportChartBucketCount = createSelector(
    [getCurrentReportChartData],
    (chartData) => (chartData ? chartData.buckets.length : 1)
);

// ReportMaps
const getReportMaps = createSelector([getReportState], (reportState) => reportState.reportMaps);
export const getReportMapList = createSelector([getReportMaps], (reportMaps) => {
    const reportIds = Object.keys(reportMaps);
    let reports = reportIds.map((id) => ({...reportMaps[id], id}));
    if (!NutClientConfig.hasQuotas) {
        reports = reports.filter((report) => report.name !== 'Quota');
    }

    return reports;
});

export const getLeadsListState = createSelector(
    [getReportState],
    (reportState) => reportState.leadsList
);
export const getSummaryStatsState = createSelector(
    [getReportState],
    (reportState) => reportState.summaryStats
);

export const getLeadsListItems = createSelector([getLeadsListState], (leadsListState) => {
    return leadsListState.listItems;
});
export const getLeadsListIsLoading = createSelector([getLeadsListState], (leadsListState) => {
    return leadsListState.isLoading;
});
export const getLeadsListIsFirstLoad = createSelector([getLeadsListState], (leadsListState) => {
    return leadsListState.isFirstLoad;
});
export const getLeadsListHasError = createSelector([getLeadsListState], (leadsListState) => {
    return Boolean(leadsListState.errorMessage);
});

export const getLeadsListLeadCount = createSelector([getLeadsListState], (leadsListState) => {
    return leadsListState.meta.count ? leadsListState.meta.count : 0;
});

export const getSummaryStatsIsLoading = createSelector(
    [getSummaryStatsState],
    (summaryStatsState) => {
        return summaryStatsState.isLoading;
    }
);

export const getSummaryStatsStats = createSelector([getSummaryStatsState], (summaryStatsState) => {
    return summaryStatsState.stats;
});
